export const ADD_TO_CART = 'ADD_TO_CART'

export const REMOVE_ITEM_CART = 'REMOVE_ITEM_CART'

export const SAVE_SHIPPING_INFO = 'SAVE_SHIPPING_INFO'

export const CLEAR_CART = 'CLEAR_CART'
